"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _transforms = require("@nteract/transforms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Fallback = function Fallback(_ref) {
  var componentStack = _ref.componentStack,
      error = _ref.error;
  return _react2.default.createElement(
    "div",
    {
      style: {
        backgroundColor: "ghostwhite",
        color: "black",
        fontWeight: "600",
        display: "block",
        padding: "10px",
        marginBottom: "20px"
      }
    },
    _react2.default.createElement(
      "h3",
      null,
      " Error: ",
      error.toString()
    ),
    _react2.default.createElement(
      "details",
      null,
      _react2.default.createElement(
        "summary",
        null,
        "stack trace"
      ),
      _react2.default.createElement(
        "pre",
        null,
        componentStack
      )
    )
  );
};

var RichestMime = function (_React$Component) {
  _inherits(RichestMime, _React$Component);

  function RichestMime(props) {
    _classCallCheck(this, RichestMime);

    var _this = _possibleConstructorReturn(this, (RichestMime.__proto__ || Object.getPrototypeOf(RichestMime)).call(this, props));

    _this.state = {
      error: null,
      info: null
    };
    return _this;
  }

  _createClass(RichestMime, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      this.setState({ error: error, info: info });
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      // eslint-disable-line class-methods-use-this
      if (nextProps && nextProps.theme && this.props && nextProps.theme !== this.props.theme) {
        return true;
      }
      // return false;
      return true;
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.error) {
        return _react2.default.createElement(Fallback, {
          componentStack: this.state.info ? this.state.info.componentStack : "",
          error: this.state.error
        });
      }

      var mimetype = (0, _transforms.richestMimetype)(this.props.bundle, this.props.displayOrder, this.props.transforms);

      if (!mimetype) {
        // If no mimetype is supported, don't return an element
        return null;
      }

      var Transform = this.props.transforms[mimetype];
      var data = this.props.bundle[mimetype];
      var metadata = this.props.metadata[mimetype];
      return _react2.default.createElement(Transform, {
        expanded: this.props.expanded,
        data: data,
        metadata: metadata,
        theme: this.props.theme,
        models: this.props.models
      });
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return RichestMime;
}(_react2.default.Component);

RichestMime.defaultProps = {
  transforms: _transforms.transforms,
  displayOrder: _transforms.displayOrder,
  expanded: false,
  theme: "light",
  metadata: {},
  bundle: {},
  models: {}
};
var _default = RichestMime;
exports.default = _default;
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Fallback, "Fallback", "src/richest-mime.js");
  reactHotLoader.register(RichestMime, "RichestMime", "src/richest-mime.js");
  reactHotLoader.register(_default, "default", "src/richest-mime.js");
  leaveModule(module);
})();

;


//////////////////
// WEBPACK FOOTER
// ./~/@nteract/display-area/lib/richest-mime.js
// module id = 122
// module chunks = 186292428941015